import { render } from "./LawyersListAddModal.vue?vue&type=template&id=e455c450"
import script from "./LawyersListAddModal.vue?vue&type=script&lang=js"
export * from "./LawyersListAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__